import React, { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ScrollToTop from "../components/ScrollToTop";
import { BeautifulLoader } from "../components/BeautifulLoader";
import Layout from "../common/Layout";
import ProtectedRoute from "./ProtectedRoute";
import ChapterUserpage from "../pages/users/pages/Chapter/pages/ChapterUserpage";
const UsersPage = lazy(() => import("../pages/users/userspage"));
const ChapterPage = lazy(() => import("../pages/Chapter/Chapter"));
const Chapterpages = lazy(() => import("../pages/Chapter/pages/chapterpages"));
const LetterForm = lazy(
  () => import("../components/ChapterPages/ChapterPopup-form"),
);
const Dashboard = lazy(() => import("../pages/dashboard/dashboard"));
const UserLoginPage = lazy(() => import("../pages/Login/Userloginpage"));
const ChapterUsers = lazy(() => import("../pages/users/pages/chapter"));
const DashboardUsers = lazy(
  () => import("../pages/users/pages/Dashboard/dashboard"),
);
const LetterPage = lazy(() => import("../pages/LetterPage"));
const LoginPage = lazy(() => import("../pages/Login/LoginPage"));

export default function AppRoutes() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Suspense fallback={<BeautifulLoader />}>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/user/login" element={<UserLoginPage />} />
          <Route element={<ProtectedRoute role="admin" />}>
            <Route element={<Layout />}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/users" element={<UsersPage />} />
              <Route path="/chapter" element={<ChapterPage />} />
              <Route path="/chapter/:slug" element={<Chapterpages />} />
              <Route path="/chapter/page/:id/create" element={<LetterForm />} />
              <Route path="/chapter/page/:id/edit" element={<LetterForm />} />
              <Route
                path="/chapter/page/:letterId/view"
                element={<LetterPage />}
              />
            </Route>
          </Route>

          <Route element={<ProtectedRoute role="user" />}>
            <Route element={<Layout />}>
              <Route path="/user" element={<DashboardUsers />} />
              <Route path="/user/chapter" element={<ChapterUsers />} />
              <Route path="/user/chapter/:slug" element={<ChapterUserpage />} />
              <Route
                path="/user/chapter/page/:id/create"
                element={<LetterForm />}
              />
              <Route
                path="/user/chapter/page/:id/edit"
                element={<LetterForm />}
              />
              <Route
                path="/user/chapter/page/:letterId/view"
                element={<LetterPage />}
              />
            </Route>
          </Route>
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}
